import { render, staticRenderFns } from "./businessLogsDetail.vue?vue&type=template&id=045030fd&scoped=true"
import script from "./businessLogsDetail.vue?vue&type=script&lang=js"
export * from "./businessLogsDetail.vue?vue&type=script&lang=js"
import style0 from "./businessLogsDetail.vue?vue&type=style&index=0&id=045030fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045030fd",
  null
  
)

export default component.exports